import Vue from 'vue';
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbvue/build/css/mdb.css';
import router from './routing.js';
import VueCookie from 'vue-cookie';
import VS2 from 'vue-script2';
import { store } from './store.js';
import VeeValidate from 'vee-validate';
import VueSocketIO from 'vue-socket.io'
import axios from 'axios';
import VueAxios from 'vue-axios';
import requestIp from 'request-ip';
import moment from 'moment';
import VueCountdownTimer from 'vuejs-countdown-timer'
import vSelect from 'vue-select'
import Loading from 'vue-loading-overlay';
import TextHighlight from 'vue-text-highlight';
import 'vue-loading-overlay/dist/vue-loading.css';
import 'vue-select/dist/vue-select.css';
import standardBanner from './components/Custom/StandardBanner.vue';
import squareBanner from './components/Custom/SquareBanner.vue';
import skyscrapperBanner from './components/Custom/SkyscrapperBanner.vue';

import App from './App.vue';

Vue.use(VS2);
Vue.use(VueCookie);
Vue.use(VeeValidate);
Vue.use(VueAxios, axios);
Vue.use(requestIp);
Vue.use(VueCountdownTimer);
Vue.use(require('vue-moment'));
Vue.prototype.moment = moment;

Vue.use(new VueSocketIO({
    debug: true,
    connection: 'http://127.0.0.1:3000',
    transports: ['websocket'],
    vuex: {
        store,
        actionPrefix: 'SOCKET_',
        mutationPrefix: 'SOCKET_'
    }
}))

Vue.component('loading', Loading)
Vue.component('v-select', vSelect)
Vue.component('text-highlight', TextHighlight);
Vue.component('standard-banner', standardBanner);
Vue.component('square-banner', squareBanner);
Vue.component('skyscrapper-banner', skyscrapperBanner);
Vue.config.productionTip = true;

new Vue({
    render: h => h(App),
    router,
    store
}).$mount('#app');